



























import { Component, Vue } from 'vue-property-decorator';
import { Mutations } from '@/ts/store/Constants';
import Order from '@/ts/Order';
import FacilityData from '@/ts/FacilityData';

@Component({

})

export default class OrderSuccessModalContent extends Vue {

    get orderDetails(): Array<object> {
        const data = [ 
                { 'label': 'Facility', value: this.facility.name },
                { 'label': 'Date', value: this.bookingDate },
                { 'label': 'Time', value: `${this.bookingTime} (${this.bookingDuration})` },
                { 'label': 'Cost', value: `${this.bookingCost.toFixed(2)} Kr.` },
                { 'label': 'Payment', value: `${this.card.brand} ending with ${this.card.last4}` },
            ];
        return data;
    }

    get order(): Order {
        return this.$store.getters['UserUpcomingPayments/getOrder'];
    }

    public seeOrderDetails(id: string) {
        this.$store.commit(Mutations.SET_PAY_FOR_ORDER_MODAL_VISIBILITY, false);
        this.$store.commit(Mutations.SET_ORDER_PAY_SUCCESS_MODAL_VISIBILITY, false);
        this.$router.push({ name: 'order-details', params: { orderId: id } });
    }

    get facility(): FacilityData {
        return this.$store.getters['SharedFacilities/getUserSelectedFacility'];
    }

    get bookingDate(): string {
        return this.$store.getters['SharedFacilities/getFacilityBookingDate'];
    }

    get bookingTime(): string {
        return this.$store.getters['SharedFacilities/getFacilityBookingTime'];
    }

    get bookingDuration(): string {
        return this.$store.getters['SharedFacilities/getFacilityBookingDuration'];
    }

    get bookingCost(): number {
        return this.$store.getters['SharedFacilities/getFacilityBookingCost'];
    }

    get card(): any {
        return this.$store.getters['CreditCards/getActiveCard'];
    }

    public goToFacilities() {
        const tabIndex = '1';
        this.$store.commit(Mutations.SET_PAY_FOR_ORDER_MODAL_VISIBILITY, false);
        this.$store.commit(Mutations.SET_ORDER_PAY_SUCCESS_MODAL_VISIBILITY, false);
        this.$store.commit(Mutations.SET_FACILITY_DETAILS_OVERLAY_VISIBILITY, false);
        this.$router.push({ name: 'shared-facilities', params: { tabIndex }});
    }

}
